var hashtag_default = {
  "fontElementMap": "GBZwB",
  "hashtag": "yLISN"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
